import { IBiLink } from '@suvo-bi-lib';

export const STATIC_PUBLIC_TOOLBAR_LINKS: IBiLink[] = [
  {
    displayName: 'Pricing',
    route: ['pricing'],
    displayIcon: '',
  },
  {
    displayName: 'FAQS',
    route: ['faqs'],
    displayIcon: '',
  }
];
